module.exports = __webpack_public_path__ + "static/media/JVsms.d2fbe3f9.mp3";